import I18n from 'I18n';
import { useMemo } from 'react';
import UISelect from 'UIComponents/input/UISelect';
import { useUnifiedEventCompletionStatus } from '../../hooks/useUnifiedEventCompletionStatus';
import { jsx as _jsx } from "react/jsx-runtime";
const EditorUnifiedEventCompletionStatusSelect = props => {
  const {
    logicGroup,
    conditionPath
  } = props;
  const {
    onUnifiedEventCompletionStatusChange
  } = useUnifiedEventCompletionStatus(logicGroup, conditionPath);
  const options = useMemo(() => {
    return [{
      value: true,
      text: I18n.text('customerDataFiltersUI.editor.unifiedEventCompletionStatusSelect.options.hasCompleted')
    }, {
      value: false,
      text: I18n.text('customerDataFiltersUI.editor.unifiedEventCompletionStatusSelect.options.hasNotCompleted')
    }];
  }, []);
  return /*#__PURE__*/_jsx(UISelect, {
    menuWidth: "auto",
    onChange: evt => onUnifiedEventCompletionStatusChange(evt.target.value),
    options: options,
    value: !logicGroup.hasNotCompletedUnifiedEvent
  });
};
export default EditorUnifiedEventCompletionStatusSelect;